const BASE_URL = 'https://fotileams.com/api';

const getToken = () => localStorage.getItem('token');

const headers = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${getToken()}`
});

export const api = {
  // ─── AUTH ────────────────────────────────────────────
  login: (employee_id, password) =>
    fetch(`${BASE_URL}/auth/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ employee_id, password })
    }).then(r => r.json()),

  // ─── ATTENDANCE (Employee) ────────────────────────────
  getMyAttendance: (month, year) =>
    fetch(`${BASE_URL}/attendance/me?month=${month}&year=${year}`, {
      headers: headers()
    }).then(r => r.json()),

  clockIn: (lat, lng, bssid, ip) =>
    fetch(`${BASE_URL}/attendance/clockin`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ lat, lng, bssid, ip })
    }).then(r => r.json()),

  clockOut: () =>
    fetch(`${BASE_URL}/attendance/clockout`, {
      method: 'POST',
      headers: headers()
    }).then(r => r.json()),

  // ─── ATTENDANCE (HR) ──────────────────────────────────
  getAllAttendance: ({ date, location_id, city, employee_id } = {}) => {
    const params = new URLSearchParams();
    if (date)        params.append('date', date);
    if (location_id) params.append('location_id', location_id);
    if (city)        params.append('city', city);
    if (employee_id) params.append('employee_id', employee_id);
    const qs = params.toString();
    return fetch(`${BASE_URL}/attendance/${qs ? `?${qs}` : ''}`, {
      headers: headers()
    }).then(r => r.json());
  },

  getAttendanceTrend: (days = 30) =>
    fetch(`${BASE_URL}/attendance/trend?days=${days}`, {
      headers: headers()
    }).then(r => r.json()),

  getDepartmentStats: () =>
    fetch(`${BASE_URL}/attendance/departments`, {
      headers: headers()
    }).then(r => r.json()),

  getAlerts: () =>
    fetch(`${BASE_URL}/attendance/alerts`, {
      headers: headers()
    }).then(r => r.json()),

  // ─── LEAVES (Employee) ───────────────────────────────
  getLeaveBalance: () =>
    fetch(`${BASE_URL}/leaves/balance`, {
      headers: headers()
    }).then(r => r.json()),

  getMyLeaves: (year) =>
    fetch(`${BASE_URL}/leaves/me?year=${year}`, {
      headers: headers()
    }).then(r => r.json()),

  applyLeave: (data) =>
    fetch(`${BASE_URL}/leaves/apply`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  // ─── LEAVES (HR) ─────────────────────────────────────
  getAllLeaves: ({ status, city, location_id } = {}) => {
    const params = new URLSearchParams();
    if (status)      params.append('status', status);
    if (city)        params.append('city', city);
    if (location_id) params.append('location_id', location_id);
    const qs = params.toString();
    return fetch(`${BASE_URL}/leaves/${qs ? `?${qs}` : ''}`, {
      headers: headers()
    }).then(r => r.json());
  },

  approveLeave: (id) =>
    fetch(`${BASE_URL}/leaves/${id}/approve`, {
      method: 'PUT',
      headers: headers()
    }).then(r => r.json()),

  rejectLeave: (id, rejection_reason) =>
    fetch(`${BASE_URL}/leaves/${id}/reject`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify({ rejection_reason })
    }).then(r => r.json()),

  // ─── SALARY (Employee) ───────────────────────────────
  getMySalary: (month, year) =>
    fetch(`${BASE_URL}/salary/me?month=${month}&year=${year}`, {
      headers: headers()
    }).then(r => r.json()),

  // ─── SALARY (HR) ─────────────────────────────────────
  getAllSalaryReports: ({ month, year, city, location_id } = {}) => {
    const params = new URLSearchParams();
    if (month)       params.append('month', month);
    if (year)        params.append('year', year);
    if (city)        params.append('city', city);
    if (location_id) params.append('location_id', location_id);
    return fetch(`${BASE_URL}/salary/reports?${params.toString()}`, {
      headers: headers()
    }).then(r => r.json());
  },

  calculateSalary: (employee_id, month, year) =>
    fetch(`${BASE_URL}/salary/calculate/${employee_id}?month=${month}&year=${year}`, {
      headers: headers()
    }).then(r => r.json()),

  // ─── EMPLOYEES (HR) ──────────────────────────────────
  getAllEmployees: ({ city, location_id, department_id, search } = {}) => {
    const params = new URLSearchParams();
    if (city)          params.append('city', city);
    if (location_id)   params.append('location_id', location_id);
    if (department_id) params.append('department_id', department_id);
    if (search)        params.append('search', search);
    const qs = params.toString();
    return fetch(`${BASE_URL}/employees/${qs ? `?${qs}` : ''}`, {
      headers: headers()
    }).then(r => r.json());
  },

  getEmployee: (id) =>
    fetch(`${BASE_URL}/employees/${id}`, {
      headers: headers()
    }).then(r => r.json()),

  createEmployee: (data) =>
    fetch(`${BASE_URL}/employees/`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  updateEmployee: (id, data) =>
    fetch(`${BASE_URL}/employees/${id}`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  deactivateEmployee: (id) =>
    fetch(`${BASE_URL}/employees/${id}`, {
      method: 'DELETE',
      headers: headers()
    }).then(r => r.json()),

  getMyProfile: () =>
    fetch(`${BASE_URL}/employees/me`, {
      headers: headers()
    }).then(r => r.json()),

  // ─── DEPARTMENTS ─────────────────────────────────────
  getAllDepartments: () =>
    fetch(`${BASE_URL}/departments/`, {
      headers: headers()
    }).then(r => r.json()),

  createDepartment: (data) =>
    fetch(`${BASE_URL}/departments/`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  updateDepartment: (id, data) =>
    fetch(`${BASE_URL}/departments/${id}`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  // ─── LOCATIONS ───────────────────────────────────────
  getAllLocations: ({ city } = {}) => {
    const params = new URLSearchParams();
    if (city) params.append('city', city);
    const qs = params.toString();
    return fetch(`${BASE_URL}/locations/${qs ? `?${qs}` : ''}`, {
      headers: headers()
    }).then(r => r.json());
  },

  createLocation: (data) =>
    fetch(`${BASE_URL}/locations/`, {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),

  updateLocation: (id, data) =>
    fetch(`${BASE_URL}/locations/${id}`, {
      method: 'PUT',
      headers: headers(),
      body: JSON.stringify(data)
    }).then(r => r.json()),
};